<template>
  <form @submit.prevent="submitDependentes">
    <div class="form__div">
      <input
        :id="'firstName' + props.formNumber"
        class="form__input"
        type="text"
        placeholder=" "
        v-model="firstName"
        required
      />
      <label :for="'firstName' + props.formNumber" class="form__label"
        >First name</label
      >
    </div>
    <div class="form__div">
      <input
        :id="'lastName' + props.formNumber"
        class="form__input"
        type="text"
        placeholder=" "
        v-model="lastName"
        required
      />
      <label :for="'lastName' + props.formNumber" class="form__label"
        >Last name</label
      >
    </div>
    <div class="form__div">
      <input
        :id="'username' + props.formNumber"
        class="form__input"
        type="text"
        placeholder=" "
        v-model="username"
        required
      />
      <label :for="'username' + props.formNumber" class="form__label"
        >Username</label
      >
    </div>
    <div class="form__div mb-4">
      <flat-pickr
        v-model="dateBirth"
        :config="config"
        placeholder="Date of birth"
        name="birthdate"
        class="date-input"
        required
      ></flat-pickr>
      <label
        v-if="dateBirth"
        :for="'dateBirth'"
        class="form__label label-float"
        :class="{ 'label-float--active': dateBirth !== '' }"
      >
        Date of birth
      </label>
    </div>
    <PhoneInput
      class="mt-4"
      v-model="phoneNumber"
      :model-value="phoneNumber"
      @onValidation="handlePhoneValidation"
      :placeholder="`Phone number (optional)`"
    />
    <div class="mb-4 form__div">
      <select class="form__input select-float" v-model="gender" required>
        <option value="" disabled selected>Select gender</option>
        <option value="Male">Male</option>
        <option value="Female">Female</option>
        <option value="Choose to Not Disclose">Choose to Not Disclose</option>
      </select>
      <label
        v-if="gender"
        :for="'gender'"
        class="form__label label-float"
        :class="{ 'label-float--active': gender !== '' }"
      >
        Gender
      </label>
    </div>
    <!-- <div class="mb-4 form__div">
      <select
        class="form__input select-float"
        v-model="trainingPurpose"
        required
      >
        <option value="" disabled selected>
          What are you using {{ appName }} for?
        </option>
        <option value="Sports">Sports</option>
        <option value="Academics">Academics</option>
        <option value="Aging Adults">Business</option>
        <option value="Aging Adults">Military/First Responders</option>
        <option value="Aging Adults">Aging Adults</option>
      </select>
      <label
        v-if="trainingPurpose"
        :for="'trainingPurpose'"
        class="form__label label-float"
        :class="{ 'label-float--active': trainingPurpose !== '' }"
      >
        What are you using {{ appName }} for?
      </label>
    </div>
    <div class="mb-4 form__div" v-if="trainingPurpose === 'Sports'">
      <select class="form__input select-float" v-model="sport" required>
        <option value="" disabled selected>Select primary sport</option>
        <option value="Baseball">Baseball</option>
        <option value="Basketball">Basketball</option>
        <option value="Boxing/MMA">Boxing/MMA</option>
        <option value="eSports">eSports</option>
        <option value="Football">Football</option>
        <option value="Golf">Golf</option>
        <option value="Gymnastics">Gymnastics</option>
        <option value="Hockey">Hockey</option>
        <option value="Lacrosse">Lacrosse</option>
        <option value="Pickleball">Pickleball</option>
        <option value="Skiing">Skiing</option>
        <option value="Soccer">Soccer</option>
        <option value="Softball">Softball</option>
        <option value="Target Sports">Target Sports</option>
        <option value="Tennis">Tennis</option>
        <option value="Track & Field">Track & Field</option>
        <option value="Volleyball">Volleyball</option>
        <option value="Wrestling">Wrestling</option>
        <option value="Other">Other</option>
      </select>
      <label
        v-if="sport"
        :for="'sport'"
        class="form__label label-float"
        :class="{ 'label-float--active': sport !== '' }"
      >
        Primary Sport
      </label>
    </div> -->
    <button
      id="b-add"
      class="mb-5 bg-mindaro w-full p-3 font-semibold"
      type="submit"
      :disabled="props.processingRegistration"
    >
      <em
        v-if="props.processingRegistration"
        class="fa fa-spinner fa-spin"
      ></em>
      Add Player
    </button>
  </form>
</template>

<script setup>
import PhoneInput from "@/components/general/PhoneInput.vue";
import { calculateAge } from "@/utils/calculateAge.js";
import "flatpickr/dist/flatpickr.css";
import { defineEmits, defineProps, ref, watch } from "vue";
import flatPickr from "vue-flatpickr-component";
import { useToast } from "vue-toastification";

// const store = useStore();

const config = {
  altInput: true,
  dateFormat: "m-d-Y",
  altFormat: "m-d-Y",
  allowInput: true,
  disableMobile: "true",
};

const toast = useToast();
const emit = defineEmits(["profileAdded"]);
const props = defineProps({
  formNumber: {
    type: Number,
    default: 0,
  },
  processingRegistration: {
    type: Boolean,
    default: false,
  },
});

const firstName = ref(null);
const lastName = ref(null);
const phoneNumber = ref("");
const acceptedOptIn = ref(false);
const username = ref(null);
const dateBirth = ref(null);
// const trainingPurpose = ref("");
// const sport = ref("");
const gender = ref("");
const phoneNumberValid = ref(false);
const phoneNumberError = ref("");

function submitDependentes() {
  if (phoneNumber.value && !phoneNumberValid.value) {
    return toast.error(
      phoneNumberError.value || "Please enter a valid phone number"
    );
  }

  const dateFormatted = formatDate(dateBirth.value);
  const data = {
    firstName: firstName.value,
    lastName: lastName.value,
    username: username.value,
    dateBirth: dateFormatted,
    trainingPurpose: "Academics", // This value is defaulted to Academics
    sport: "", // This value is defaulted to empty string
    gender: gender.value,
    phoneNumber: phoneNumber.value,
    acceptedOptIn: acceptedOptIn.value,
  };

  return emit("profileAdded", data);
}

// const appName = computed(() => store.getters["location/getAppName"]);

function formatDate(date) {
  const dateAdded = new Date(date.replace(/-/g, "/"));
  return `${dateAdded.getFullYear()}-${
    dateAdded.getMonth() + 1
  }-${dateAdded.getDate()}`;
}

function handlePhoneValidation(isValid) {
  phoneNumberValid.value = isValid;
  phoneNumberError.value =
    !isValid && phoneNumber.value ? "Please enter a valid phone number" : "";
}

watch(dateBirth, (newValue) => {
  if (newValue) {
    const age = calculateAge(newValue);
    if (age > 13) {
      acceptedOptIn.value = true;
    } else {
      acceptedOptIn.value = false;
    }
  }
});

// watch(trainingPurpose, (newValue) => {
//   if (newValue !== "Sports") {
//     sport.value = "";
//   }
// });
</script>

<style>
#b-add:disabled {
  cursor: not-allowed;
  opacity: 0.7;
}

#b-add {
  background-color: #edfe86;
  border: none;
  padding: 11px;
  width: 100%;
  cursor: pointer;
}

.date-input {
  font-size: 16px;
  width: 100%;
  padding: 0.6rem 1.2rem;
  background-color: #ecf0f5;
  font-weight: 500;
  z-index: 2;
}

.date-input::placeholder {
  color: #81848d;
  font-weight: 400;
  font-size: 15px;
  padding-top: 1.1rem;
}

.date-input:focus {
  border: 3px solid #1d2e48;
  border-radius: 0%;
  background-color: #fff;
}

.date-input:not(:placeholder-shown).date-input:not(:focus) {
  border: 3px solid #1d2e48;
  background-color: #fff;
  border-radius: 0%;
}
</style>
